import { selectJBPSettingsActualsSync } from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { getEffectiveActualsSync } from '../../lib'

import { selectEffectiveCockpitFYear } from './selectEffectiveCockpitFYear'

export const selectEffectiveCockpitActualsSync = createSelector(
  [selectEffectiveCockpitFYear, selectJBPSettingsActualsSync],
  (selectedFYear, actualsSync) =>
    getEffectiveActualsSync({
      selectedFYear,
      realFYear: actualsSync.fYearActuals,
      realCurrentFQuarter: actualsSync.fQuarterActuals,
      realFQuarterActualsPercentage: actualsSync.fQuarterActualsPercentage,
    })
)
